import { Model as l } from "../../../../../../../model.js";
class c extends l {
  constructor(e) {
    super(), this.minBalance = e.minBalance;
  }
}
export {
  c as TierCycleRuleModel
};
//# sourceMappingURL=tierCycleRule.model.js.map
